import { Theme } from '@mui/material/styles';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme: Theme) => createStyles({
  wrapperHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    pointerEvents: 'none',
  },
  headerLogo: {
    pointerEvents: 'all',
    '& > a': {
      color: theme.palette.primary.main,
      fontSize: '20px',
      fontWeight: 'bold',
      textTransform: 'uppercase',
      display: 'flex',
    },
  },
  headerButton: {
    pointerEvents: 'all',
    backgroundColor: '#F6F7F6',
    borderRadius: '10px',
    minWidth: '40px',
    width: '40px',
    height: '40px',
    '&:hover': {
      backgroundColor: '#F6F7F6',
    },
    '& span[class*="startIcon"]': {
      margin: '0px',
    },
    '&.favoriteIcon #svgPath': {
      transform: 'scale(0.5)',
    },
    [theme.breakpoints.up('xl')]: {
      fontSize: '18px',
      minWidth: '56px',
      width: '56px',
      height: '56px',
      '& svg': {
        width: '28px',
        height: '28px',
      },
    },
  },
  headerWrapperButton: {
    [theme.breakpoints.up('md')]: {
      marginRight: '68px',
    },
    '& > *': {
      marginLeft: '10px',
      [theme.breakpoints.up('xl')]: {
        marginLeft: '16px',
      },
    },
    '&:empty': {
      display: 'none',
    },
  },
  appLogo: {
    maxHeight: '40px',
    maxWidth: '140px',
    objectFit: 'contain',
    width: '100%',
    [theme.breakpoints.up('xl')]: {
      maxHeight: '56px',
      maxWidth: '216px',
    },
  },
  callToUs: {
    color: 'transparent',
    position: 'absolute',
    width: '100%',
    height: '100%',
  },
}));
